// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@keyframes pulse-data-v-19fd7290{50%{opacity:.5}}.header-item[data-v-19fd7290]{margin-left:-.5rem;margin-right:-.5rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
